import { render, staticRenderFns } from "./EmailAssets.vue?vue&type=template&id=0007ed5c&scoped=true"
import script from "./EmailAssets.vue?vue&type=script&lang=js"
export * from "./EmailAssets.vue?vue&type=script&lang=js"
import style0 from "./EmailAssets.vue?vue&type=style&index=0&id=0007ed5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0007ed5c",
  null
  
)

export default component.exports